module.exports = "/fast-coin/img/coin/anim/in/coin_in_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_016.png
// module id = 2286
// module chunks = 5